module.exports = __webpack_public_path__ + "static/media/discontrol023.31403eaa.jpg";